export const italian = {
  seo: {
    title: 'Cas client : Ristorante Il Municipio | Bistroo',
    description: "Comment Bistroo a aidé le restaurant italien Il Municipio à gérer l'affluence et à se développer en ligne.",
  },
  hero: {
    title: 'Comment Bistroo a aidé notre restaurant italien à gérer l\'affluence et la croissance',
    description:
      "Ristorante Il Municipio est un restaurant italien renommé établi dans la région de Twente, spécialisé dans les pizzas et pâtes authentiques. Leur savoir-faire a été reconnu lorsqu'ils ont remporté la 1ère place au Championnat des Pizzailos aux Pays-Bas (NK Pizzabakken) à la Horecava en 2025.",
  },
  testimonials: {
    1: {
      text: '"Bistroo a vraiment réfléchi avec nous et proposé des solutions adaptées à nos besoins et à nos ambitions croissantes. De nouvelles possibilités ont été rapidement imaginées et mises en œuvre, ce qui a permis une collaboration sans faille et une amélioration de notre service client"',
      name: 'Roberta',
      job_title: 'Hôtesse',
    },
    2: {
      text: '"Depuis que nous sommes passés à Bistroo, nous n\'avons plus à prendre de commandes par téléphone, ce qui nous fait gagner un temps précieux et nous donne plus de place pour le service à nos clients"',
      name: 'Edwin ter Haar',
      job_title: 'Propriétaire',
    },
  },
  challenge: {
    paragraph: {
      title: 'Nouvelle solution et nouvelles opportunités',
      text: 'Le restaurant est connu pour sa passion des ingrédients de haute qualité et des plats italiens traditionnels. Il Municipio collabore avec Bistroo depuis plus de 2 ans et raconte brièvement les défis qu\'ils avaient avant la collaboration et les solutions qu\'apporte Bistroo.',
    },
    paragraph_2: {
      title: 'Le défi',
      bullets: {
        1: 'Pendant les heures chargées, Ristorante Il Municipio pouvait être submergé par les commandes, obligeant le restaurant à faire attendre le personnel et les clients plus longtemps.',
        2: 'La prise de commandes téléphoniques demandait beaucoup de temps au personnel et entraînait parfois des erreurs ou des malentendus.',
        3: 'En tant qu\'entreprise qui change et grandit rapidement, Ristorante Il Municipio avait besoin d\'une solution flexible pouvant évoluer avec ses besoins changeants.',
        4: '',
      },
    },
  },
  solution: {
    title: 'La solution',
    checklist: {
      1: "La solution de commande en ligne de Bistroo a offert à Ristorante Il Municipio la possibilité d'envoyer des confirmations numériques aux clients pour leurs commandes. Les clients pouvaient vérifier leurs commandes pour d'éventuelles erreurs, ce qui améliorait la précision et la satisfaction.",
      2: 'En passant à Bistroo, le personnel de Ristorante Il Municipio n\'avait plus à prendre de commandes téléphoniques, leur faisant gagner un temps précieux qu\'ils pouvaient consacrer à la préparation de délicieux plats et à offrir un excellent service aux clients.',
      3: 'Bistroo a réfléchi avec Ristorante Il Municipio et proposé des solutions adaptées à leurs besoins changeants et à leurs ambitions croissantes. De nouvelles possibilités ont été rapidement imaginées et mises en œuvre, ce qui a permis une collaboration sans faille et un meilleur service client.',
      4: 'Bistroo est toujours prêt à soutenir Ristorante Il Municipio, quel que soit le moment. Ce soutien continu a donné au restaurant la tranquillité d\'esprit et la confiance dans leur processus de commande en ligne.',
    },
  },
  conclusion: {
    title: 'La conclusion',
    text: {
      1: "Grâce à la solution de commande en ligne de Bistroo, Ristorante Il Municipio a pu non seulement améliorer son efficacité opérationnelle, mais aussi augmenter la satisfaction de ses clients et exploiter les opportunités de croissance. Le restaurant a particulièrement apprécié le système de confirmation numérique et les économies de temps réalisées grâce à l'élimination des commandes téléphoniques.",
      2: 'En tant que partenaire disponible 24h/24 et 7j/7 et qui s\'adapte aux besoins du restaurant, Ristorante Il Municipio recommande vivement Bistroo à d\'autres entreprises de restauration qui recherchent une solution de commande en ligne flexible et efficace.',
    },
  },
}
